<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="起止日期">
						<el-date-picker v-model="queryParams.createDates" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="团队" label-width="60px">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队" :clearable="true">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="化学品代号"><el-input v-model="queryParams.chemicalsCode" :clearable="true" placeholder="请输入化学品代号"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="tags" label="化学品分类">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
								{{tag}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="chemicalsCode" label="化学品代号"></el-table-column>
					<el-table-column prop="chemicalsTitle" label="标签"></el-table-column>
					<el-table-column prop="value" label="累积现场到达量(公斤)">
						<template slot-scope="scope">
							<el-button type="text" @click="handleDetail(scope.row)">{{scope.row.value}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="所属团队"></el-table-column>
					<el-table-column prop="date" label="日期"></el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
			<el-col :span="24">
				<el-table v-loading="detailLoading" :data="detailList" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark"
					@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="tags" label="化学品分类">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
								{{tag}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="chemicalsCode" label="化学品代号"></el-table-column>
					<el-table-column prop="chemicalsTitle" label="标签"></el-table-column>
					<el-table-column prop="value" label="现场到达量(公斤)"></el-table-column>
					<el-table-column prop="deviceTitle" label="设备名称"></el-table-column>
					<el-table-column prop="addTime" label="入库时间"></el-table-column>
					<el-table-column prop="creatorName" label="操作人"></el-table-column>
					<el-table-column prop="createTime" label="操作时间"></el-table-column>
				</el-table>
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryDetailParams.currentPage"
					:page-size="queryDetailParams.pageSize" :total="detailTotalNum" @size-change="pageDetailSizeChange" @current-change="pageDetailCurrentChange"></el-pagination>
			</el-col>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'mngr/chemicals/device/store',
				queryUrl: '/queryStatistics',
				name: '化学品入库',
				teamList: [],
				queryDetailParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				queryParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					},
					date:""
				},
				detailTotalNum: 0,
				detailTotalPage: 0,
				detailList: [],
				detailLoading: true,
				rules: {
					deviceId: [{
							required: true,
							message: '请输入设备id',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					chemicalsCode: [{
							required: true,
							message: '请输入化学品代号',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					chemicalsTitle: [{
							required: true,
							message: '请输入化学品名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度最长支持100',
							trigger: 'blur'
						}
					],
					value: [{
							required: true,
							message: '请输入化学品值',
							trigger: 'blur'
						},
						{
							max: 11,
							message: '长度最长支持11',
							trigger: 'blur'
						}
					],
					addTime: [{
							required: true,
							message: '请输入入库时间',
							trigger: 'blur'
						},
						{
							max: -1,
							message: '长度最长支持-1',
							trigger: 'blur'
						}
					],
				}
			};
		},
		filters: {},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeUpdate() {},
			handleDetail(row) {
				this.queryDetailParams.chemicalsCode = row.chemicalsCode;
				this.queryDetailParams.teamId = row.teamId;
				this.queryDetailParams.currentPage = 1;
				this.queryDetailParams.pageSize = 10;
				this.dialogVisible = true;
				this.getDetailList()
			},
			pageDetailCurrentChange(val) {
				// 分页
				this.queryDetailParams.currentPage = val;
				this.getDetailList();
			},
			pageDetailSizeChange(val) {
				//调整每页显示条数
				this.queryDetailParams.pageSize = val;
				this.queryDetailParams.currentPage = 1;
				this.getDetailList();
			},
			getDetailList() {
				// 查询列表
				let that = this;
				this.detailLoading = true;
				this.$http({
						method: 'POST',
						url: 'mngr/chemicals/device/store/queryStatisticsDetail',
						data: this.queryDetailParams
					})
					.then(function(res) {
						that.detailList = res.data.data;
						if (!that.noPage) {
							that.detailTotalNum = res.data.page.totalNum;
							that.detailTotalPage = res.data.page.totalPage;
						}
						that.detailLoading = false;
					})
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			}
		},
		mounted: function() {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth()).padStart(2, '0'); // 月份从 0 开始，需 +1
			//this.queryParams.date= `${year}-${month}`; // "2024-01"
			this.queryTeamList();
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
	/deep/ .el-tag {
		margin-right: 5px;
	}
	/deep/ .el-range-editor--small .el-range-separator{
		width:20px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/operation/chemicalsDeviceStore.vue